import React from "react";
import PropTypes from "prop-types";
import Translate from "react-translate-component";
import WalletBlockSelection from "./WalletBlockSelection";
import WalletHeaderSelection from "./WalletHeaderSelection";
import AccountBlockSelection from "./AccountBlockSelection";
import AccountHeaderSelection from "./AccountHeaderSelection";
export default class RegistrationSelector extends React.Component {
  static propTypes = {
    children: PropTypes.element
  };
  static contextTypes = {
    router: PropTypes.object.isRequired
  };
  static defaultProps = {
    children: null
  };

  constructor() {
    super();
    this.state = {
      activeWalletModel: true
    };
  }

  onSelect(route) {
    this.props.history.push(`/registration/${route}`);
  }

  changeActiveModel(isActiveWallet) {
    this.setState({
      activeWalletModel: isActiveWallet
    });
  }

  renderHeader(isWalletSection) {
    const {
      activeWalletModel
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: "small-horizontal small-only-block"
    }, /*#__PURE__*/React.createElement(WalletHeaderSelection, {
      active: activeWalletModel,
      onChangeActive: () => this.changeActiveModel(true),
      forSmall: !isWalletSection
    }), /*#__PURE__*/React.createElement(AccountHeaderSelection, {
      active: !activeWalletModel,
      onChangeActive: () => this.changeActiveModel(false),
      forSmall: isWalletSection
    }));
  }

  render() {
    if (this.props.children) {
      return this.props.children;
    }

    const {
      activeWalletModel
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: "grid-block align-center registration-layout"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-block shrink vertical text-center registration-selector"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "registration.title",
      component: "p",
      className: "registration-title"
    }), /*#__PURE__*/React.createElement("div", {
      className: "registration-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "v-align"
    }, /*#__PURE__*/React.createElement("div", {
      className: `${!activeWalletModel ? "inactive-model-block" : ""} selection-block align-center plate`
    }, this.renderHeader(true), /*#__PURE__*/React.createElement(WalletBlockSelection, {
      onSelect: () => this.onSelect("local"),
      active: activeWalletModel,
      onChangeActive: () => this.changeActiveModel(true)
    })), /*#__PURE__*/React.createElement("div", {
      className: `${activeWalletModel ? "inactive-model-block" : ""} selection-block align-center plate`
    }, this.renderHeader(false), /*#__PURE__*/React.createElement(AccountBlockSelection, {
      onSelect: () => this.onSelect("cloud"),
      active: !activeWalletModel,
      onChangeActive: () => this.changeActiveModel(false)
    }))))));
  }

}